import { sortBy } from 'lodash';
import { toast } from 'react-toastify';

export const PJE_FILE_MAX_SIZE_BY_TYPE = {
  PDF: 3 * 1024 * 1024,
  MP3: 10 * 1024 * 1024,
  MP4: 10 * 1024 * 1024,
};

export const parseFileProcessStatus = processingStatus => {
  if (!processingStatus) {
    return '';
  }
  if (processingStatus === 'PROCESSING') {
    return 'Em processamento';
  } else if (processingStatus === 'WAITING') {
    return 'Aguardando';
  } else if (processingStatus === 'DONE') {
    return 'Finalizado';
  } else if (processingStatus === 'ERROR') {
    return 'Erro ao processar arquivo';
  } else if (processingStatus === 'CANCELED') {
    return 'Cancelado';
  }
  return 'Desconhecido';
};

export const parseFileProcessError = doc => {
  if (!doc.processingStatus || doc.processingStatus !== 'ERROR') {
    return '';
  }
  const lastErrorLog = sortBy(doc.errorLogs, 'createdAt').reverse()[0];
  const lastErrorLogMessage = lastErrorLog?.errorDescription || '';
  if (lastErrorLogMessage.includes('No such object')) {
    return 'Arquivo não encontrado';
  }
  const tokens = lastErrorLogMessage.split(':');
  const parsedMessage = (tokens[0] || '') + '. ' + (tokens[tokens.length - 1] || '');
  return parsedMessage;
};

export const PJE_ALLOWED_EXTENSIONS = ['PDF', 'MP3', 'MP4'];

export const validateSubjectCrimes = (crimes, pjeMainSubject) => {
  const mainSubjectCode = String(pjeMainSubject?.id);
  const crimeSubjectCodes = (crimes || []).map(crime => String(crime?.subject?.code));
  if (mainSubjectCode && !crimeSubjectCodes.includes(mainSubjectCode)) {
    toast.warn(
      'O assunto CNJ principal selecionado não corresponde a nenhum dos assuntos relacionados aos crimes cadastrados no inquérito. Caso necessário, verifique os crimes cadastrados',
    );
  }
};
